import * as React from "react";
import { forwardRef } from "react";
const SvgUnCheckedCheckbox = ({
  title,
  titleId,
  ...props
}, ref) => <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M12 .8H2A1.2 1.2 0 0 0 .8 2v10A1.2 1.2 0 0 0 2 13.2h10a1.2 1.2 0 0 0 1.2-1.2V2A1.2 1.2 0 0 0 12 .8ZM.5 2A1.5 1.5 0 0 1 2 .5h10A1.5 1.5 0 0 1 13.5 2v10a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 12V2Z" stroke="currentColor" /></svg>;
const ForwardRef = forwardRef(SvgUnCheckedCheckbox);
export default ForwardRef;